export default {
  'contact-mail': 'blog@pixartprinting.com',
  'business-name': 'Pixartprinting S.p.A., sociedad unipersonal',
  'privacy-policy': 'Política de privacidad',
}
